import { Fragment } from 'react';

import Column, { ColumnsRow, ColumnsWrapper } from 'bloko/blocks/column';
import VSpacing from 'bloko/blocks/vSpacing';

import StatisticBody from 'components/Statistic';

import { Header } from 'components/Header/Header';

const Statistic = () => (
    <Fragment>
        <Header />
        <ColumnsWrapper>
            <ColumnsRow>
                <Column xs="4" s="8" m="12" l="16">
                    <StatisticBody />
                    <VSpacing base={12} />
                </Column>
            </ColumnsRow>
        </ColumnsWrapper>
    </Fragment>
);

export default Statistic;
